<!--
	TaxonomySelectDropdown.svelte

    new 08/18 - rewrite of <KeywordSelectBar>

    This component uses the AutoComplete from "simple-svelte-autocomplete" (not SMUI)
    Note the capital C in AutoComplete - this is a different component.

    Selecting from this or the sibling TreeViewer component will add Chips.
-->

<script>
    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import AutoComplete from "simple-svelte-autocomplete"

    export let store;
    export let taxName;
    
    $: allNodes = getAllNodes($store, taxName);
    let selectedNode = null;            // the one selected in the AutoComplete

    onMount(() => {
    })

    const getAllNodes = (storeVal, tax) => {
        let taxes = storeVal.taxonomies || null;
        if (!taxes) return [];
        let taxonomy = taxes[tax] || null;
        if (!taxonomy) return [];
        return taxonomy.getAllNodes();
    }

    // initial event has no node
    const onAutoCompleteChange = (node) => {
        if (!node) return;
        node.isSelected = true;
        console.log(node);
        $store = $store;                            // refresh store

        // must clear the input area after selecting
        let timer = setTimeout(() => {
            selectedNode = null;
            clearTimeout(timer);
        }, 500)
    }

</script>


<style>
    .tax-select-bar {
        width: 100%;
        min-height: 1.5em;
        border-radius: 5px;
        color: var(--tcare-primary);
        border: 1px solid var(--tcare-primary);
    }

    :global(.tax-select-auto) {
        width: 100%;
        height: 100%;
    }

    :global(.tax-select-auto .autocomplete-list) {
        margin-top: 3px;
    }
    
    :global(.tax-select-auto input) {
        width: 100%;
        height: 100%;
        margin-top: 3px;
        border: none;
        outline: none;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="tax-select-bar">
    <AutoComplete
        className='tax-select-auto'
        items={allNodes}
        bind:selectedItem={selectedNode}
        placeholder="Select Keywords"
        onChange={onAutoCompleteChange}
        maxItemsToShowInList=8
        showClear
        hideArrow
        labelFieldName="label"
        tabindex={-1}
    />
</div>
